<div class="vc-edit-treatment" *ngIf="treatment">
  <section class="vc-edit-treatment__section">
    <header class="vc-edit-treatment__section-header">
      <i class="fas fa-briefcase-medical"></i>
      <strong>{{ 'COMMON.TREATMENT' | translate }}</strong>
    </header>

    <div class="vc-edit-treatment__summary">
      <div class="vc-edit-treatment__summary-name">
        {{ treatment.treatment?.name || ('COMMON.NO_NAME' | translate) }}
      </div>
      <div class="vc-edit-treatment__summary-meta">
        {{ treatment.treatment?.category?.name || '' }}
      </div>
    </div>

    <div class="vc-edit-treatment__form-grid">
      <div class="vc-edit-treatment__field">
        <label for="treatment-price">
          {{ 'COMMON.PRICE' | translate }}
          <span *ngIf="currencyLabel">({{ currencyLabel }})</span>
        </label>
        <p-inputnumber
          inputId="treatment-price"
          name="price"
          [(ngModel)]="treatment.price"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [min]="0"
          [disabled]="isPaid"
          size="small"
          fluid
        ></p-inputnumber>
        <small class="p-error" *ngIf="errors.price">
          {{ errors.price | translate }}
        </small>
      </div>

      <div class="vc-edit-treatment__field vc-edit-treatment__field--full">
        <label for="treatment-comment">{{ 'COMMON.COMMENT' | translate }}</label>
        <textarea
          id="treatment-comment"
          pInputTextarea
          [(ngModel)]="treatment.comment"
          rows="4"
          autoResize="true"
        ></textarea>
      </div>
    </div>

    <div class="vc-edit-treatment__locked-note" *ngIf="isPaid">
      <i class="fas fa-lock"></i>
      {{ 'APPOINTMENT.PATIENT.TREATMENTS.PAYMENT.PRICE_LOCKED' | translate }}
    </div>

    <div class="vc-edit-treatment__actions">
      <button
        pButton
        icon="fas fa-save"
        [label]="'COMMON.SAVE' | translate"
        class="p-button-sm"
        [disabled]="isSaving"
        (click)="updateTreatment()"
      ></button>
    </div>
  </section>
</div>
